import { StyleProvider } from "@ant-design/cssinjs";
import { App as AntApp, ConfigProvider } from "antd";
import uzUZ from "antd/locale/uz_UZ";
import type { ReactNode } from "react";
import { darkTheme, lightTheme, useThemeStore } from "@/shared/theme";

interface AntdProviderProps {
	children: ReactNode;
}

export function AntdProvider({ children }: AntdProviderProps) {
	const mode = useThemeStore((state) => state.mode);

	return (
		<StyleProvider layer>
			<ConfigProvider
				locale={uzUZ}
				theme={mode === "dark" ? darkTheme : lightTheme}
				button={{ autoInsertSpace: false }}
			>
				<AntApp
					message={{ maxCount: 3, duration: 2.5 }}
					notification={{ placement: "bottomRight" }}
				>
					{children}
				</AntApp>
			</ConfigProvider>
		</StyleProvider>
	);
}
